import { store } from 'Store'
import { SnackbarUtilsConfigurator } from 'Util/Snackbar'
import setupSentry from 'Util/setupSentry'
import Theme from 'Util/theme'
import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { SnackbarProvider } from 'notistack'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { addLocale, type LocaleData, useLocale } from 'ttag'
import fiTranslations from '../i18n/fi.po.json'
import { App } from './App'
import './index.css'
import { WALTTI_ENABLED_FEATURES } from 'Util/constants'
import * as serviceWorker from './serviceWorker'

// Only setup Sentry for Waltti environments (not HSL) and not in development mode
if (WALTTI_ENABLED_FEATURES && import.meta.env.PROD) {
  setupSentry()
}

const locale = import.meta.env.VITE_LOCALE || 'fi'

const translationObj = fiTranslations as LocaleData
addLocale(locale, translationObj)

useLocale(locale) // NOSONAR since this is done according to ttag docs

const container = document.getElementById('root')
// biome-ignore lint/style/noNonNullAssertion: This is safe because the root element is always present
const root = createRoot(container!)

const render = () => {
  root.render(
    <StrictMode>
      <ThemeProvider theme={Theme}>
        <CssBaseline>
          <Provider store={store}>
            <SnackbarProvider maxSnack={3}>
              <SnackbarUtilsConfigurator />
              <App />
            </SnackbarProvider>
          </Provider>
        </CssBaseline>
      </ThemeProvider>
    </StrictMode>
  )
}

render()

if (import.meta.env.DEV && import.meta.hot) {
  import.meta.hot.accept('./App', render)
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
